import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  getAllContent,
  getAllBerita,
  getCalonPendamping,
} from "../../services/api";
import "./Dashboard.css";
import { getStoredUser } from "../../utils/authStorage";

const Dashboard = () => {
  const [stats, setStats] = useState({
    content: 0,
    berita: 0,
    pendaftaran: 0,
  });
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = getStoredUser();
    if (userData) {
      setUser(userData);
    }
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [contentRes, beritaRes, calonRes] = await Promise.all([
        getAllContent().catch(() => ({ data: { data: [] } })),
        getAllBerita().catch(() => ({ data: { data: [] } })),
        // Use calon-peserta endpoint to count only 'Calon Peserta'
        getCalonPendamping().catch(() => ({ data: { data: [] } })),
      ]);

      // Ensure we count only items whose jenisberita is exactly 'berita'
      const beritaCount = Array.isArray(beritaRes.data?.data)
        ? beritaRes.data.data.filter(
            (item) => (item.jenisberita || "").toLowerCase() === "berita",
          ).length
        : 0;

      setStats({
        content: contentRes.data.data?.length || 0,
        berita: beritaCount,
        pendaftaran: calonRes.data.data?.length || 0,
      });
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  const statsCards = [
    {
      title: "Total Content",
      value: stats.content,
      icon: "fa-file-alt",
      color: "#10b981",
      bgColor: "#d1fae5",
    },
    {
      title: "Total Berita",
      value: stats.berita,
      icon: "fa-newspaper",
      color: "#3b82f6",
      bgColor: "#dbeafe",
    },
    {
      title: "Pendaftaran P3H",
      value: stats.pendaftaran,
      icon: "fa-users",
      color: "#f59e0b",
      bgColor: "#fef3c7",
    },
  ];

  return (
    <div className="dashboard-page">
      <div
        className="page-header-banner"
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
        }}
      >
        <div className="page-header-content">
          <div className="page-header-left">
            <div className="page-header-icon">
              <i className="fas fa-tachometer-alt"></i>
            </div>
            <div>
              <h1 className="page-header-title">Dashboard</h1>
              <p className="page-header-subtitle">
                Selamat datang, <strong>{user?.username}</strong>!
              </p>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {/* Stats Cards - Only for Admin (R.1) */}
          {user?.role === "R.1" && (
            <Row className="mb-4">
              {statsCards.map((stat, index) => (
                <Col md={4} key={index} className="mb-3">
                  <Card className="stat-card">
                    <Card.Body>
                      <div className="stat-content">
                        <div
                          className="stat-icon"
                          style={{
                            backgroundColor: stat.bgColor,
                            color: stat.color,
                          }}
                        >
                          <i className={`fas ${stat.icon}`}></i>
                        </div>
                        <div className="stat-details">
                          <div className="stat-title">{stat.title}</div>
                          <div className="stat-value">{stat.value}</div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}

          <Row>
            <Col md={6} className="mb-3">
              <Card className="info-card">
                <Card.Body>
                  <h5 className="card-title mb-3">
                    <i className="fas fa-user me-2"></i>
                    Informasi User
                  </h5>
                  <div className="info-list">
                    <div className="info-item">
                      <i className="fas fa-user-circle text-success me-2"></i>
                      <span>
                        <strong>Username:</strong> {user?.username || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-id-badge text-primary me-2"></i>
                      <span>
                        <strong>User ID:</strong> {user?.userid || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-shield-alt text-success me-2"></i>
                      <span>
                        <strong>Role:</strong> {user?.role || "-"}
                      </span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-fingerprint text-warning me-2"></i>
                      <span>
                        <strong>Unik ID:</strong> {user?.unik_id || "-"}
                      </span>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-3">
              <Card className="info-card">
                <Card.Body>
                  <h5 className="card-title mb-3">
                    <i className="fas fa-info-circle me-2"></i>
                    Informasi Sistem
                  </h5>
                  <div className="info-list">
                    <div className="info-item">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      <span>Sistem berjalan normal</span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-database text-primary me-2"></i>
                      <span>Database terhubung</span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-shield-alt text-success me-2"></i>
                      <span>Keamanan aktif</span>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default Dashboard;
